import errorIcon from 'assets/icons/Error.svg';

export default (theme) => ({
  modalContainer: {
    margin: theme.spacing(2.5),
    marginTop: theme.spacing(4),
    flexDirection: 'column',
  },
  guidelinesHeading: {
    marginTop: theme.spacing(2),
  },
  guidelinesList: {
    listStyleType: 'disc',
    listStylePosition: 'inside',
    textAlign: 'right',
    pl: 4,
    containerType: 'inline-size',
  },
  guidelinesListItem: {
    display: 'list-item',
    paddingRight: 0,
    fontSize: 15,
    textAlign: 'justify',
    marginBottom: '-1em',
    '&:after': {
      content: '',
      display: 'inline-block',
      width: '100%',
    },
  },
  blurAndClear: {
    fontSize: 16,
  },
  '@media screen and (max-width: 414px)': {
    guidelinesListItem: {
      fontSize: 14,
    },
    blurAndClear: {
      fontSize: '3.8vw',
    },
  },
  '@media screen and (max-width: 390px)': {
    guidelinesListItem: {
      fontSize: 12,
    },
  },
  '@media screen and (max-width: 340px)': {
    guidelinesListItem: {
      fontSize: 10,
    },
  },
  '@media screen and (max-width: 300px)': {
    guidelinesListItem: {
      fontSize: 8,
    },
  },
  correctPicGridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& > div': {
      width: 100,
      height: 100,
    },
  },
  correct: {
    fill: 'green',
    marginTop: theme.spacing(1),
  },
  cancel: {
    fill: 'red',
    marginTop: theme.spacing(1),
  },
  uploadPicButton: {
    cursor: 'pointer',
    border: 0,
    textTransform: 'uppercase',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(4, 0, 1, 0),
    color: theme.color.white,
    backgroundColor: theme.color.black,
  },
  uploadError: {
    position: 'relative',
    color: theme.color.red,
    fontSize: 16,
    margin: theme.spacing(3, 4, 0),
    padding: theme.spacing(0, 4, 0),
    '&:before': {
      content: '""',
      backgroundColor: theme.color.red,
      maskImage: `url(${errorIcon})`,
      display: 'block',
      width: 20,
      height: 20,
      position: 'absolute',
      top: 15,
      left: 0,
    },
  },
  uploadContainer: {
    margin: theme.spacing(2.5),
    marginTop: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'center',
  },
  uploadAvatar: {
    width: 120,
    height: 120,
  },
  uploadButtonSection: {
    justifyContent: 'center',
    '& > button': {
      margin: theme.spacing(4, 2, 1, 0),
    },
  },
  whiteButton: {
    backgroundColor: theme.color.white,
    border: `1px solid ${theme.color.black}`,
    color: theme.color.black,
    '&:hover': {
      backgroundColor: theme.color.white,
      border: `1px solid ${theme.color.teal}`,
      color: theme.color.teal,
    },
  },
  uploadStatus: {
    marginBottom: 25,
  },
  doneRemoveButton: {
    width: 149,
  },
});
